<template>
  <div v-for="(item,index) in userLogList" :key="index" style="margin: 12px 0;">
    <span>{{ item.createTime }}</span>
    <el-tag v-if="item.adminName" size="small" style="margin-left: 8px;">{{ item.adminName }}</el-tag>
    <p>{{ item.marriageName }}</p>
  </div>
</template>

<script>
export default {
name: "UserLog",
  props: {
    userLogList: {
      type: Array,
      default: [],
    }
  }
}
</script>

<style scoped>

</style>
